(function (window, document, undefined) {
  'use strict';
  window.tp = window.tp || [];
  let appUpsellButton = false;
    
  // Create a logger instance with 💰 prefix.
  let logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1F4B0));
  } catch(e) {
    logger = { log: function() {} };
  }
  
  const onAppUpsellButtonClicked = () => {
    window.tp.customVariables = window.tp.customVariables || {};
    window.tp.customVariables.upsellCampaign = window.tp.customVariables.upsellCampaign || '';
    
    const upsellData = document.querySelector('#upsellData');
    let postId = false,
      parsedData = {};
  
    try {
      parsedData = JSON.parse(upsellData.innerHTML);
      postId = parsedData.postId;
    } catch (e) {
      logger.log('could not parse upsellData', e);
    }
  
    document.dispatchEvent(new CustomEvent('vodl-upsell-button-clicked', {
      detail: {
        campno: tp.customVariables.upsellCampaign,
        postId,
      }
    }));
    
  };
    
  const showAppUpsellButton = (text) => {
    if (!text || !appUpsellButton) {
      return;
    }
    
    const buttonLabel = appUpsellButton.querySelector('.vodl-button__label');
    
    if (!buttonLabel) {
      return;
    }
    
    buttonLabel.innerHTML = text;
    appUpsellButton.style.display = 'block';
  };
    
  const init = () => {
    appUpsellButton = document.querySelector('.vodl-app-upsell-button');
  
    if (!appUpsellButton) {
      return;
    }

    appUpsellButton.addEventListener('click', onAppUpsellButtonClicked);
  };
    
  init();
    
  window.RussMedia = window.RussMedia || {};
  window.RussMedia.Piano = window.RussMedia.Piano || {};
  $.extend(window.RussMedia.Piano, {
    showAppUpsellButton: showAppUpsellButton,
  });
})(window, document);